module.exports = __webpack_public_path__ + "static/media/do-these-before-you-design-mobile-ux.5bf2e6ba.svg";